import { RouteConfig } from 'vue-router';
import RepairPlanTasks from '@/views/repairplan/RepairPlanTask.vue';
import ServiceProviderOverview from '@/views/management/RepairShop/ServiceProviderOverview.vue';
import ApplyDamageAssessor from '@/views/management/RepairShop/ApplyDamageAssessor.vue';
import ApplyLawyerOffice from '@/views/management/RepairShop/ApplyLawyerOffice.vue';
import PageModal from '@/components/modals/PageModal.vue';
import CompanyAds from '@/views/management/RepairShop/Ads/CompanyAds.vue';
import CreateAd from '@/views/management/RepairShop/Ads/CreateAd.vue';
import ChatOverview from '@/views/management/RepairShop/Chat/ChatOverview.vue';
import CreateChat from '@/views/management/RepairShop/Chat/CreateChat.vue';
import Userprofile from '@/views/default/Userprofile.vue';
import ChatDetail from '@/views/management/RepairShop/Chat/ChatDetail.vue';
import AdPreview from '@/views/management/RepairShop/Ads/AdPreview.vue';
import ChatDocumentsModal from '@/views/management/RepairShop/Chat/ChatDocumentsModal.vue';
import OrderDocumentationTypes from '@/views/management/RepairShop/OrderDocumentationTypes.vue';
import AdFilters from '@/views/management/RepairShop/Ads/AdFilters.vue';
import SelectAdType from '@/views/management/RepairShop/Ads/SelectAdType.vue';
import AdTemplatesOverview from '@/views/management/RepairShop/Ads/AdTemplatesOverview.vue';
import EmployeeApp from '@/views/management/RepairShop/EmployeeApp.vue';
import ConnectApp from '@/views/management/RepairShop/ConnectApp.vue';

const routes: Array<RouteConfig> = [
	{
		path: '/repairplantasks',
		name: 'repairplantasks',
		component: RepairPlanTasks,
	},
	{
		path: '/employee_app',
		name: 'employee_app',
		component: EmployeeApp,
	},
	{
		path: '/connect_app',
		name: 'connect_app',
		component: ConnectApp,
	},
	{
		path: '/orderdocumentationtypes',
		name: 'orderdocumentationtypes',
		component: OrderDocumentationTypes,
	},
	{
		path: '/service_provider',
		name: 'repair_shop.service_provider',
		component: ServiceProviderOverview,
		children: [
			{
				path: 'apply_damage_assessor',
				name: 'repair_shop.service_provider.apply_damage_assessor',
				component: PageModal,
				props: {
					component: ApplyDamageAssessor,
					title: 'Gutachter beantragen',
					saveButtonText: 'beantragen',
				},
			},
			{
				path: 'apply_lawyer_office',
				name: 'repair_shop.service_provider.apply_lawyer_office',
				component: PageModal,
				props: {
					component: ApplyLawyerOffice,
					title: 'Kanzlei beantragen',
					saveButtonText: 'beantragen',
				},
			},
		],
	},
	{
		path: '/company_ads',
		name: 'repair_shop.company_ads',
		component: CompanyAds,
		children: [
			{
				path: 'select_ad_type',
				name: 'repair_shop.company_ads.select_ad_type',
				component: PageModal,
				props: {
					component: SelectAdType,
					title: 'Marketing-Aktion erstellen',
					saveButtonText: null,
					modalStyle: 'width: fit-content; align-self: center',
				},
			},
			{
				path: 'ad_preview/:id',
				name: 'repair_shop.company_ads.ad_preview',
				component: PageModal,
				props: {
					component: AdPreview,
					title: 'Vorschau der Marketing-Aktion',
					hint: 'Die tatsächliche Formatierung des Layouts auf den Mobilgeräten kann von der Vorschau abweichen',
					saveButtonText: null,
					modalStyle: 'width: fit-content; align-self: center',
				},
			},
		],
	},
	{
		path: '/company_ads/ad_templates',
		name: 'repair_shop.ad_templates',
		component: AdTemplatesOverview,
		children: [
			{
				path: 'ad_preview/:id',
				name: 'repair_shop.ad_templates.ad_preview',
				component: PageModal,
				props: {
					component: AdPreview,
					title: 'Vorschau der Marketing-Aktion',
					hint: 'Die tatsächliche Formatierung des Layouts auf den Mobilgeräten kann von der Vorschau abweichen',
					saveButtonText: null,
					modalStyle: 'width: fit-content; align-self: center',
				},
			},
		],
	},
	{
		path: '/company_ads/create_ad/:id?&type=:type?',
		name: 'repair_shop.company_ads.create_ad',
		component: CreateAd,
		children: [
			{
				path: '/company_ads/create_ad/:id?&type=:type?/filter',
				name: 'repair_shop.company_ads.ad_filters',
				component: PageModal,
				props: {
					component: AdFilters,
					title: 'Filter auswählen - Kunden-Daten durchsuchen',
					hint:
						'Filtern Sie die Datenbank nach Ihren Wünschen und senden im Anschluss nach den ausgewählten Filtern eine neue bzw. vorbereitete Marketing-Aktion',
					saveButtonText: 'Filter wählen',
					props: true,
				},
			},
		],
	},
	{
		path: '/chats',
		name: 'repair_shop.chats',
		component: ChatOverview,
		children: [
			{
				path: 'create_chat/:customerid',
				name: 'repair_shop.chats.create_chat',
				component: PageModal,
				props: {
					component: CreateChat,
					title: 'Chat hinzufügen',
					saveButtonText: 'Speichern',
					props: true,
				},
			},
		],
	},
	{
		path: '/chats/:id',
		name: 'repair_shop.chats_detail',
		component: ChatDetail,
		props: true,
		children: [
			{
				path: 'send_document/:vehicleid',
				name: 'repair_shop.chats_detail.send_document',
				component: PageModal,
				props: {
					component: ChatDocumentsModal,
					title: 'Dokument versenden',
					saveButtonText: 'Senden',
					props: true,
				},
			},
		],
	},
];

export default routes;
